import icon from 'assets/img/icons/success-green-big.svg'

const MakeOfferSuccess = ({ closeWindow }) => {
  return (
    <div className="modal-window__wrapper" onClick={(e) => e.stopPropagation()}>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Offer Submitted!</h5>
        <p className="modal-window__info">You will be notified whether your offer is accepted or declined..</p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-submit" onClick={closeWindow}>Done</button>
      </footer>
    </div>
  )
}

export default MakeOfferSuccess;
